import { Injectable } from '@angular/core';
import { 
  DeviceDefaultParams as DefaultParams, 
  DeviceDefaultParamsLimited as DefaultParamsLimited 
} from '@app/models/device-default-params.class';
import { Device, DeviceCreate } from '@app/models/device.interface';
import { DevicesService } from '@lib/core';
import { Observable, map } from 'rxjs';
import { PostgrestQueryHelper } from './postgrest-query-helper.service';
import { ToastService } from '@app/services/toast.service';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
@Injectable({
  providedIn: 'root'
})
export class DeviceHelperService {

  constructor(
    private service: DevicesService,
    private pg: PostgrestQueryHelper,
    private toast: ToastService,
    private auth: AuthService,
    private router: Router,
  ) { }

  getAll(): Observable<Device[]> {
    let params = new DefaultParamsLimited();
    if(this.auth.has('device_update')){
      params = new DefaultParams();
    }
    return this.service.devicesGet(params)
      .pipe(map(x => <Device[]>x));
  }
  search(serial_number: string, provider_id: number, device_status_id: number): Observable<Device[]> {
    let params = new DefaultParamsLimited();
    if(this.auth.has('device_update')){
      params = new DefaultParams();
    }
    params.serialNumber = 'like.' + serial_number +'*';
    if(provider_id != 0){
      params.providerId = 'eq.' + provider_id;
    }
    if(device_status_id != 0){
      params.deviceStatusId = 'eq.' + device_status_id;
    }
    return this.service.devicesGet(params)
      .pipe(map(x => <Device[]>x));
  }
  getById(id: number): Observable<Device> {
    let params = <any>new DefaultParamsLimited();
    if(this.auth.has('device_update')){
      params = <any>new DefaultParams();
    }
    params.id = 'eq.' + id;
    return this.service.devicesGet(params)
      .pipe(map(x => <Device>x[0]));
  }
  create(input: DeviceCreate) {
    return this.service.devicesPost({
      devices: <any>input,
      prefer: "return=representation"
    }, 'response')
    .pipe(map(response => response.body[0]))
    .pipe(map(body => {
      //console.log(body)
      return (<Device>body).id;
    }));
  }
  createMany(input: DeviceCreate[]) {
    var params = this.pg.defaultParams();
    return this.pg.post('devices', params, input, {httpHeaderAccept: 'application/json'}).subscribe({
      next: (success) => {
        this.toast.message({ message: 'Devices imported successfully', type: 'success' })
        //this.router.navigate(['devices']);
        window.location.reload();
      },
      error: (err: AppHttpError) => {
        this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
      }
    });
  }
  update(id: number, input: DeviceCreate) {
    return this.service.devicesPatch({
      id: 'eq.'+id,
      devices: <any>input
    }, 'response')
    .pipe(map(response => response.ok));
  }
}
